import type { Campaign, CampaignStatus, CampaignStats } from '@conversia/shared-types';
import type { Paginated } from '@/lib/types';
import { api } from './client';

/** Endpoints de campañas. Prefijo: /api/campaigns */

export interface ListCampaignsParams {
  status?: CampaignStatus;
  skip?: number;
  take?: number;
}

export interface CreateCampaignInput {
  name: string;
  channelId?: string;
  templateId?: string;
  scheduledAt?: string;
}

export const listCampaigns = (params: ListCampaignsParams = {}) =>
  api.get<Paginated<Campaign>>('/api/campaigns', { query: params });

export const getCampaign = (id: string) => api.get<Campaign>(`/api/campaigns/${id}`);

export const getProgress = (id: string) =>
  api.get<CampaignStats>(`/api/campaigns/${id}/progress`);

export const createCampaign = (input: CreateCampaignInput) =>
  api.post<Campaign>('/api/campaigns', input);

export const updateCampaign = (id: string, input: Partial<CreateCampaignInput>) =>
  api.patch<Campaign>(`/api/campaigns/${id}`, input);

/** Carga destinatarios desde un CSV crudo. */
export const addRecipients = (id: string, csv: string) =>
  api.post<{ added: number; skipped: number }>(`/api/campaigns/${id}/recipients`, { csv });

export const setStatus = (id: string, status: CampaignStatus) =>
  api.post<Campaign>(`/api/campaigns/${id}/status`, { status });

export const start = (id: string) => setStatus(id, 'RUNNING');
export const pause = (id: string) => setStatus(id, 'PAUSED');
